import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles(theme => ({
  dropzone: {
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  active: {
    backgroundColor: theme.palette.action.selected,
    borderColor: theme.palette.primary.main
  }
}));
const FileUploader = ({
  onChange,
  acceptedFiles,
  filesLimit,
  ...rest
}) => {
  const classes = useStyles();
  const onDrop = useCallback(files => {
    onChange && onChange(files);
  }, [onChange]);
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = useDropzone({
    onDrop,
    accept: acceptedFiles,
    maxFiles: filesLimit
  });
  return /*#__PURE__*/React.createElement("div", getRootProps({
    className: `${classes.dropzone}${isDragActive ? ` ${classes.active}` : ''}`
  }), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, isDragActive ? 'Drop files here...' : 'Drag & drop files here, or click to select'));
};
export default FileUploader;